module.exports = __webpack_public_path__ + "files/b086ff0b0769ac9ef7da31b58b6cb569.png";